import useContactSales from '@contentlab/hooks/use-contact-sales';
import AnalyticsService from '@/services/analytics/AnalyticsService';
import {FLOW_NAMES} from '@/lib/analytics/analyticsConstants';

export const OPEN_PRICING_TYPE = {
  REDIRECT: 'REDIRECT',
  MODAL: 'MODAL',
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export type OpenPricingType =
  (typeof OPEN_PRICING_TYPE)[keyof typeof OPEN_PRICING_TYPE];

function useOpenPricing() {
  const onContactSalesClick = useContactSales({
    flowName: FLOW_NAMES.CONTENT_STUDIO.PRICING,
    interactionLocation: 'open-pricing',
  });

  return (
    _openType: OpenPricingType,
    source: string,
    _callbacks?: {
      onCancelCallback?: () => void;
      onSuccessCallback?: () => void;
    }
  ) => {
    AnalyticsService.createFlow(FLOW_NAMES.CONTENT_STUDIO.PRICING, {
      source,
      screen_presentation_id:
        AnalyticsService.getActiveScreenPresented().screen_presentation_id,
    });
    onContactSalesClick();
  };
}

export default useOpenPricing;
